// src/lib/cognito.js
// All Cognito auth calls and token helpers

import { COGNITO_CONFIG, API_ENDPOINT } from './constants';

const COGNITO_DOMAIN = `cognito-idp.${COGNITO_CONFIG.region}.amazonaws.com`;

const cognitoRequest = async (target, body) => {
  const r = await fetch(`https://${COGNITO_DOMAIN}/`, {
    method:'POST',
    headers:{'Content-Type':'application/x-amz-json-1.1','X-Amz-Target':target},
    body:JSON.stringify(body)
  });
  return r.json();
};

export const authSignUp = (e,p,n) => cognitoRequest('AWSCognitoIdentityProviderService.SignUp',{ClientId:COGNITO_CONFIG.clientId,Username:e,Password:p,UserAttributes:[{Name:'email',Value:e},{Name:'name',Value:n}]});
export const authConfirmSignUp = (e,c) => cognitoRequest('AWSCognitoIdentityProviderService.ConfirmSignUp',{ClientId:COGNITO_CONFIG.clientId,Username:e,ConfirmationCode:c});
export const authSignIn = (e,p) => cognitoRequest('AWSCognitoIdentityProviderService.InitiateAuth',{AuthFlow:'USER_PASSWORD_AUTH',ClientId:COGNITO_CONFIG.clientId,AuthParameters:{USERNAME:e,PASSWORD:p}});
export const authForgotPassword = (e) => cognitoRequest('AWSCognitoIdentityProviderService.ForgotPassword',{ClientId:COGNITO_CONFIG.clientId,Username:e});
export const authConfirmPassword = (e,c,p) => cognitoRequest('AWSCognitoIdentityProviderService.ConfirmForgotPassword',{ClientId:COGNITO_CONFIG.clientId,Username:e,ConfirmationCode:c,Password:p});
export const authUpdateAttribute = (accessToken, name, value) => cognitoRequest('AWSCognitoIdentityProviderService.UpdateUserAttributes',{AccessToken:accessToken,UserAttributes:[{Name:name,Value:value}]});
export const authVerifyAttribute = (accessToken, name, code) => cognitoRequest('AWSCognitoIdentityProviderService.VerifyUserAttribute',{AccessToken:accessToken,AttributeName:name,Code:code});

export const isTokenExpired = (token) => {
  try { const p=JSON.parse(atob(token.split('.')[1])); return p.exp*1000<Date.now(); }
  catch { return true; }
};
export const refreshAuthToken = (refreshTok) =>
  cognitoRequest('AWSCognitoIdentityProviderService.InitiateAuth',{
    AuthFlow:'REFRESH_TOKEN_AUTH', ClientId:COGNITO_CONFIG.clientId,
    AuthParameters:{REFRESH_TOKEN:refreshTok}
  });

export const saveToCloud = async (token, dataType, data) => {
  if(token==='bypass-token') return {success:true};
  try {
    const r = await fetch(`${API_ENDPOINT}/data`,{
      method:'POST',
      headers:{'Content-Type':'application/json','Authorization':token},
      body:JSON.stringify({dataType,data})
    });
    return r.json();
  } catch(e) { console.error(`Save ${dataType}:`,e); return {success:false}; }
};
export const loadFromCloud = async (token) => {
  if(token==='bypass-token') return {};
  try {
    const r = await fetch(`${API_ENDPOINT}/data`,{
      method:'GET',
      headers:{'Content-Type':'application/json','Authorization':token}
    });
    const res = await r.json();
    const d = {};
    if(res.items) res.items.forEach(i=>{ d[i.dataType]=i.data; });
    return d;
  } catch(e) { console.error('Load:',e); return {}; }
};